/* Goofinery Deadpan theme — progressive enhancement only. Every feature works without this file. */
(function () {
  'use strict';

  var goof = window.goof || {};
  var routes = goof.routes || {};
  var strings = goof.strings || {};

  /* ---------- Helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || goof.moneyFormat || '${{amount}}';
    function withDelimiters(n, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  // Find the first element matching selector that belongs to this root (not to a nested root).
  function own(root, selector) {
    var list = root.querySelectorAll(selector);
    for (var i = 0; i < list.length; i++) {
      if (list[i].closest('[data-product-root]') === root) return list[i];
    }
    return null;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function refreshCartCount() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  var toastTimer;
  function toast(message) {
    var el = document.getElementById('CartToast');
    if (!el) return;
    el.querySelector('[data-toast-message]').textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 6000);
  }

  /* ---------- Variant picker ---------- */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      var data = this.querySelector('[data-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.form = document.getElementById(this.dataset.form);
      this.root = this.closest('[data-product-root]') || document;
      this.addEventListener('change', this.onChange.bind(this));
      if (this.form) {
        var fallback = this.form.querySelector('[data-variant-fallback]');
        var input = this.form.querySelector('[data-variant-input]');
        if (fallback && input) { fallback.disabled = true; input.disabled = false; }
      }
      this.applyRequested();
      // Bring price, form, photo and labels in line with the checked options (also after the browser restores form state).
      this.refresh(false);
    }

    // Shopify resolves option-value links (?option_values=…) on the server. The page starts on the
    // featured photo's color, so switch to the variant Shopify resolved when such a link was used.
    applyRequested() {
      if (this.dataset.updateUrl !== 'true' || !this.dataset.requested) return;
      var params = new URLSearchParams(window.location.search);
      if (!params.has('option_values') || params.has('variant')) return;
      this.select(Number(this.dataset.requested));
    }

    select(id) {
      var variant = this.variants.find(function (v) { return v.id === id; });
      if (!variant) return;
      this.querySelectorAll('fieldset').forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (input) { input.checked = input.value === variant.options[i]; });
      });
    }

    selected() {
      return Array.prototype.map.call(this.querySelectorAll('fieldset'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    findVariant(options) {
      return this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
    }

    markAvailability(options) {
      var self = this;
      this.querySelectorAll('fieldset').forEach(function (fs, index) {
        fs.querySelectorAll('input').forEach(function (input) {
          var candidate = options.slice();
          candidate[index] = input.value;
          var available = self.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === candidate[i]; });
          });
          var label = input.nextElementSibling;
          if (label) {
            label.classList.toggle('is-unavailable', !available);
            var note = label.querySelector('[data-unavailable-label]');
            if (note) note.hidden = available;
          }
        });
        var shown = fs.querySelector('[data-option-selected]');
        if (shown) shown.textContent = options[index] || '';
      });
    }

    onChange() {
      this.refresh(true);
    }

    refresh(updateUrl) {
      var options = this.selected();
      var variant = this.findVariant(options);
      this.markAvailability(options);
      this.updateForm(variant);
      this.updatePrice(variant);
      if (variant) {
        this.updateMedia(variant);
        if (updateUrl && this.dataset.updateUrl === 'true' && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    updateForm(variant) {
      if (!this.form) return;
      var input = this.form.querySelector('[data-variant-input]');
      var button = this.form.querySelector('[data-add-button]');
      var label = this.form.querySelector('[data-add-label]');
      var error = this.form.querySelector('[data-form-error]');
      if (error) error.hidden = true;
      if (!variant) {
        if (button) button.disabled = true;
        if (label) label.textContent = strings.unavailable;
        return;
      }
      if (input) input.value = variant.id;
      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? strings.addToCart : strings.soldOut;
    }

    updatePrice(variant) {
      var price = own(this.root, '[data-price]');
      if (!price || !variant) return;
      var current = price.querySelector('[data-price-current]');
      var compare = price.querySelector('[data-price-compare]');
      if (current) current.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      price.classList.toggle('price--sale', !!onSale);
      if (compare) {
        compare.hidden = !onSale;
        var s = compare.querySelector('s');
        if (s && onSale) s.textContent = formatMoney(variant.compare_at_price);
      }
    }

    updateMedia(variant) {
      if (!variant.featured_media) return;
      var gallery = own(this.root, '[data-gallery]');
      if (!gallery) return;
      var item = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (!item) return;
      gallery.prepend(item);
      gallery.scrollTo({ left: 0, behavior: 'auto' });
      this.root.querySelectorAll('[data-thumb]').forEach(function (t) {
        if (String(t.dataset.thumb) === String(variant.featured_media.id)) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }
  }
  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);
  // A page restored from the back/forward cache keeps its DOM; re-sync in case its form state was restored separately.
  if (window.addEventListener) {
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      document.querySelectorAll('variant-picker').forEach(function (picker) { if (picker.refresh) picker.refresh(false); });
    });
  }

  /* ---------- Add to cart (single form and "add both") ---------- */
  function showFormError(form, message) {
    var error = form && form.querySelector('[data-form-error]');
    if (error) { error.textContent = message || strings.error; error.hidden = false; }
  }

  function addItems(items) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || strings.error);
        return data;
      });
    });
  }

  // One add request per form at a time. Repeated clicks, taps or Enter presses while a request is
  // pending are ignored. `disabled` stays owned by the variant picker (sold-out/unavailable), so busy
  // state uses aria attributes only and can never re-enable an unavailable variant.
  var busyEls = typeof WeakSet === 'function' ? new WeakSet() : null;
  function isBusy(el) { return busyEls ? busyEls.has(el) : el.getAttribute('aria-busy') === 'true'; }
  function setBusy(els, on) {
    els.forEach(function (el) {
      if (!el) return;
      if (busyEls) { if (on) busyEls.add(el); else busyEls.delete(el); }
      if (on) { el.setAttribute('aria-busy', 'true'); el.setAttribute('aria-disabled', 'true'); }
      else { el.removeAttribute('aria-busy'); el.removeAttribute('aria-disabled'); }
    });
  }

  // Capture phase, so the submit is already marked handled (defaultPrevented) when Shopify's own
  // /cart/add form listener sees it. Otherwise Shopify reports the add twice: once for the form
  // submit and once for the /cart/add.js request.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-add-form]')) return;
    if (!window.fetch) return;
    event.preventDefault();
    if (isBusy(form)) return;
    var button = form.querySelector('[data-add-button]');
    var idField = form.querySelector('input[name="id"]:not([disabled]), select[name="id"]:not([disabled])');
    var qtyField = form.querySelector('[name="quantity"]');
    if (!idField || (button && button.disabled)) return;
    var error = form.querySelector('[data-form-error]');
    if (error) error.hidden = true;
    setBusy([form, button], true);
    addItems([{ id: Number(idField.value), quantity: qtyField ? Math.max(1, Number(qtyField.value) || 1) : 1 }])
      .then(function (data) {
        var title = data.items && data.items[0] ? data.items[0].product_title : '';
        toast((strings.added || '').replace('[title]', title));
        return refreshCartCount();
      })
      .catch(function (err) { showFormError(form, err.message); })
      .finally(function () { setBusy([form, button], false); });
  }, true);

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-add-both]');
    if (!trigger) return;
    event.preventDefault();
    if (isBusy(trigger)) return;
    var ids = trigger.getAttribute('data-add-both').split(',');
    var items = [];
    var forms = [];
    for (var i = 0; i < ids.length; i++) {
      var form = document.getElementById(ids[i]);
      if (!form) return;
      if (isBusy(form)) return;
      var button = form.querySelector('[data-add-button]');
      var idField = form.querySelector('input[name="id"]:not([disabled]), select[name="id"]:not([disabled])');
      if (!idField || (button && button.disabled)) {
        showFormError(form, strings.soldOut);
        return;
      }
      forms.push(form);
      items.push({ id: Number(idField.value), quantity: 1 });
    }
    var buttons = forms.map(function (f) { return f.querySelector('[data-add-button]'); });
    var all = [trigger].concat(forms, buttons);
    setBusy(all, true);
    addItems(items)
      .then(function () { toast(strings.addedBoth); return refreshCartCount(); })
      .catch(function (err) { showFormError(forms[0], err.message); })
      .finally(function () { setBusy(all, false); });
  });

  /* ---------- Matching set page: one of each of two different shirts, added together ----------
     Each shirt card is its own product root with a normal variant picker, so color and size stay
     independent. Both selected variants (two different products) go to /cart/add.js in one request. The saving shown here is
     only a preview: Shopify's automatic discounts decide it, and the success message reads the real
     cart before claiming it. */
  function getCart() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(strings.error);
      return r.json();
    });
  }
  // Network failures surface as TypeError with a browser message; show the theme's own text instead.
  function friendly(err) { return err instanceof TypeError || !err.message ? strings.error : err.message; }
  function quantitiesOf(cart, ids) {
    var out = {};
    ids.forEach(function (id) { out[id] = 0; });
    (cart.items || []).forEach(function (item) { if (item.variant_id in out) out[item.variant_id] += item.quantity; });
    return out;
  }

  class PairBuy extends HTMLElement {
    connectedCallback() {
      this.discount = Number(this.dataset.discount) || 0;
      this.shirts = Array.prototype.slice.call(this.querySelectorAll('[data-pair-shirt]'));
      this.button = this.querySelector('[data-pair-add]');
      this.label = this.querySelector('[data-pair-add-label]');
      this.error = this.querySelector('[data-pair-error]');
      this.status = this.querySelector('[data-pair-status]');
      this.addEventListener('change', this.onChange.bind(this));
      this.button.addEventListener('click', this.add.bind(this));
      this.update();
    }

    onChange() {
      this.clearMessages();
      this.update();
    }

    // A set must be exactly two different products (never two of the same shirt).
    distinct() {
      if (this.shirts.length !== 2) return false;
      var a = this.shirts[0].dataset.productId;
      var b = this.shirts[1].dataset.productId;
      return !!a && !!b && a !== b;
    }

    variantOf(shirt) {
      var picker = shirt.querySelector('variant-picker');
      if (picker && picker.findVariant) return picker.findVariant(picker.selected()) || null;
      var input = shirt.querySelector('[data-variant-input]');
      if (!input) return null;
      return { id: Number(input.value), price: Number(input.dataset.price), available: input.dataset.available === 'true' };
    }

    update() {
      var variants = this.shirts.map(this.variantOf, this);
      var ready = this.distinct() && variants.length === 2 && variants.every(function (v) { return v && v.available; }) && variants[0].id !== variants[1].id;
      var regular = variants.reduce(function (sum, v) { return sum + (v ? v.price : 0); }, 0);
      var regularEl = this.querySelector('[data-pair-regular]');
      var totalEl = this.querySelector('[data-pair-total]');
      if (regularEl) regularEl.textContent = ready ? formatMoney(regular) : '—';
      if (totalEl) totalEl.textContent = ready ? formatMoney(Math.max(0, regular - this.discount)) : '—';
      this.button.disabled = !ready;
      var missing = variants.some(function (v) { return !v; });
      this.label.textContent = ready ? (strings.pairAdd || strings.addToCart) : (missing ? strings.unavailable : strings.soldOut);
      this.variants = variants;
      return ready;
    }

    clearMessages() {
      this.error.hidden = true;
      this.status.hidden = true;
    }

    fail(message) {
      this.error.textContent = message || strings.error;
      this.error.hidden = false;
    }

    add(event) {
      event.preventDefault();
      if (isBusy(this.button) || !this.update()) { if (!this.distinct()) this.fail(strings.error); return; }
      this.clearMessages();
      var self = this;
      var ids = this.variants.map(function (v) { return v.id; });
      var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
      var before = null;
      setBusy([this.button], true);
      getCart()
        .then(function (cart) { before = quantitiesOf(cart, ids); return addItems(items); })
        .then(function () { return getCart(); })
        .then(function (cart) {
          var after = quantitiesOf(cart, ids);
          var added = ids.every(function (id, i) {
            var expected = before[id] + ids.filter(function (x) { return x === id; }).length;
            return after[id] >= expected;
          });
          updateCartCount(cart.item_count);
          if (!added) { self.fail(strings.pairPartial); return; }
          var saving = (cart.items || []).some(function (item) {
            return ids.indexOf(item.variant_id) !== -1 && (item.line_level_discount_allocations || []).some(function (d) { return d.amount > 0; });
          });
          var message = saving && self.discount > 0 ? strings.pairAddedSaving : strings.pairAdded;
          self.status.querySelector('[data-pair-status-text]').textContent = message;
          self.status.hidden = false;
          toast(message);
        })
        .catch(function (err) {
          // Shopify rejected the request: report what is actually in the cart now.
          return getCart().then(function (cart) {
            updateCartCount(cart.item_count);
            var after = quantitiesOf(cart, ids);
            var some = before && ids.some(function (id) { return after[id] > before[id]; });
            self.fail(some ? strings.pairPartial : friendly(err));
          }).catch(function () { self.fail(friendly(err)); });
        })
        .finally(function () { setBusy([self.button], false); });
    }
  }
  if (!customElements.get('pair-buy')) customElements.define('pair-buy', PairBuy);
  var setTeaser = document.querySelector('[data-set-url]');
  if (setTeaser && window.location.hash === '#pair') window.location.replace(setTeaser.getAttribute('data-set-url'));

  /* ---------- Cart page: instant quantity changes ----------
     Lines are identified by Shopify's line-item key, which survives removals and reordering.
     Edits are collected per key, sent together to /cart/update.js, and only one request is in flight
     at a time; anything changed meanwhile goes in the next request. The section is re-rendered only
     when nothing is waiting, so a response can never overwrite a newer edit. */
  function cartSection() { return document.querySelector('[data-cart-section]'); }

  var cartQueue = {};      // line key -> latest requested quantity, not yet sent
  var cartQueued = false;  // cartQueue has entries
  var cartTimer = null;    // debounce before sending
  var cartInFlight = false;
  var cartWaiters = [];    // resolved when the cart is idle
  var lastKey = null;      // for restoring focus after re-render

  function cartIdle() { return !cartInFlight && !cartQueued && cartTimer === null; }

  function settleWaiters() {
    if (!cartIdle()) return;
    var waiters = cartWaiters;
    cartWaiters = [];
    waiters.forEach(function (resolve) { resolve(); });
  }

  function whenCartIdle() {
    return new Promise(function (resolve) {
      if (cartIdle()) resolve();
      else cartWaiters.push(resolve);
    });
  }

  function showCartError(message) {
    var error = document.querySelector('[data-cart-error]');
    if (error) { error.textContent = message || strings.error; error.hidden = false; }
  }

  function renderCartSection(html) {
    var section = cartSection();
    if (!section || !html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
    if (!fresh) return;
    section.innerHTML = fresh.innerHTML;
    var focusTarget = (lastKey && section.querySelector('[data-line-qty][data-line-key="' + lastKey + '"]'))
      || section.querySelector('[data-line-qty]')
      || section.querySelector('.page-title');
    if (focusTarget && focusTarget.focus) focusTarget.focus({ preventScroll: true });
  }

  function queueLine(key, quantity, delay) {
    if (!key || !cartSection()) return;
    cartQueue[key] = Math.max(0, Number(quantity) || 0);
    cartQueued = true;
    lastKey = key;
    if (cartTimer !== null) clearTimeout(cartTimer);
    cartTimer = setTimeout(function () { cartTimer = null; flushCart(); }, delay);
  }

  function flushCart() {
    var section = cartSection();
    if (cartInFlight || !cartQueued || !section) { settleWaiters(); return; }
    var updates = cartQueue;
    cartQueue = {};
    cartQueued = false;
    cartInFlight = true;
    var id = section.dataset.sectionId;
    section.setAttribute('aria-busy', 'true');
    var error = document.querySelector('[data-cart-error]');
    if (error) error.hidden = true;
    fetch(routes.cartUpdate + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: [id], sections_url: window.location.pathname })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || strings.error);
          return data;
        });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (!cartQueued && cartTimer === null) renderCartSection(cart.sections && cart.sections[id]);
      })
      .catch(function (err) {
        showCartError(err.message);
        // Re-sync the page with the server's cart so the visible quantities are true again.
        if (cartQueued || cartTimer !== null) return;
        return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
          .then(function (r) { return r.json(); })
          .then(function (data) { if (!cartQueued && cartTimer === null) renderCartSection(data[id]); })
          .catch(function () {});
      })
      .finally(function () {
        cartInFlight = false;
        var s = cartSection();
        if (s && cartIdle()) s.removeAttribute('aria-busy');
        if (cartQueued && cartTimer === null) flushCart();
        else settleWaiters();
      });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-line-qty]');
    if (!input) return;
    queueLine(input.dataset.lineKey, input.value, 250);
  });

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (step) {
      var input = step.closest('[data-qty]').querySelector('[data-line-qty]');
      input.value = Math.max(0, (Number(input.value) || 0) + Number(step.dataset.qtyStep));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var remove = event.target.closest('[data-line-remove]');
    if (remove && cartSection() && remove.dataset.lineKey) {
      event.preventDefault();
      // Keep the no-JS form consistent in case checkout is submitted before the response arrives.
      var qty = cartSection().querySelector('[data-line-qty][data-line-key="' + remove.dataset.lineKey + '"]');
      if (qty) qty.value = 0;
      queueLine(remove.dataset.lineKey, 0, 0);
    }
  });

  // Checkout while quantity changes are pending: send them first, then continue to checkout.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('#CartForm') || !cartSection()) return;
    if (cartIdle()) return;
    var submitter = event.submitter;
    event.preventDefault();
    if (cartTimer !== null) { clearTimeout(cartTimer); cartTimer = null; flushCart(); }
    whenCartIdle().then(function () {
      var target = document.getElementById('CartForm');
      if (!target) return;
      var name = submitter && submitter.name;
      var button = name && target.querySelector('button[name="' + name + '"]');
      if (button && target.requestSubmit) { target.requestSubmit(button); return; }
      if (name) {
        var carry = document.createElement('input');
        carry.type = 'hidden';
        carry.name = name;
        carry.value = (submitter && submitter.value) || '';
        target.appendChild(carry);
      }
      target.submit();
    });
  });

  /* ---------- Rich-text tables (e.g. size tables in product descriptions) ----------
     Wide tables scroll sideways inside a wrapper. When the wrapper actually overflows it becomes a
     labelled, keyboard-focusable region so the hidden columns can be reached without a mouse. */
  function fitTable(wrap) {
    var table = wrap.firstElementChild;
    var overflows = wrap.scrollWidth > wrap.clientWidth + 1;
    if (overflows) {
      var caption = table && table.caption ? table.caption.textContent.trim() : '';
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', caption || strings.tableScroll || 'Table');
    } else {
      wrap.removeAttribute('tabindex');
      wrap.removeAttribute('role');
      wrap.removeAttribute('aria-label');
    }
  }
  var tableObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(function (entries) { entries.forEach(function (e) { fitTable(e.target); }); })
    : null;
  var wrappedTables = 0;
  document.querySelectorAll('.rte table').forEach(function (table) {
    if (table.parentElement && table.parentElement.classList.contains('rte-table')) return;
    var wrap = document.createElement('div');
    wrap.className = 'rte-table';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
    fitTable(wrap);
    if (tableObserver) tableObserver.observe(wrap);
    wrappedTables += 1;
  });
  if (wrappedTables && !tableObserver) {
    window.addEventListener('resize', function () { document.querySelectorAll('.rte-table').forEach(fitTable); });
  }

  /* ---------- Facets: apply on change ---------- */
  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-facets-form]');
    if (!form) return;
    if (event.target.type === 'number') return;
    form.requestSubmit ? form.requestSubmit() : form.submit();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var form = event.target.closest && event.target.closest('[data-facets-form]');
    if (form && event.target.type === 'number') { event.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.submit(); }
  });

  /* ---------- Product recommendations ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (!this.dataset.url || this.querySelector('.product-grid')) return;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        fetch(self.dataset.url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim().length) self.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- Header: close drawers on Escape, one open at a time ---------- */
  function setHeaderBottom() {
    var header = document.querySelector('[data-header]');
    if (header) document.documentElement.style.setProperty('--header-bottom', header.getBoundingClientRect().bottom + 'px');
  }
  document.addEventListener('toggle', function (event) {
    var el = event.target;
    if (!(el instanceof HTMLDetailsElement)) return;
    if (el.matches('[data-menu-drawer]')) {
      setHeaderBottom();
      document.body.style.overflow = el.open ? 'hidden' : '';
    }
    if (el.open && el.matches('[data-menu-drawer], [data-header-search]')) {
      document.querySelectorAll('[data-menu-drawer][open], [data-header-search][open]').forEach(function (other) {
        if (other !== el) other.open = false;
      });
      if (el.matches('[data-header-search]')) {
        var field = el.querySelector('input[type="search"]');
        if (field) setTimeout(function () { field.focus(); }, 0);
      }
    }
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-menu-drawer][open], [data-header-search][open], [data-facets][open]').forEach(function (d) {
      d.open = false;
      var summary = d.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  /* ---------- Product info taller than the viewport: stick by its bottom edge ---------- */
  var stickyInfo = document.querySelectorAll('.product__info');
  if (stickyInfo.length) {
    var fitInfo = function () {
      stickyInfo.forEach(function (el) {
        el.style.top = Math.min(96, window.innerHeight - el.offsetHeight - 24) + 'px';
      });
    };
    fitInfo();
    window.addEventListener('resize', fitInfo, { passive: true });
    if (window.ResizeObserver) {
      var infoObserver = new ResizeObserver(fitInfo);
      stickyInfo.forEach(function (el) { infoObserver.observe(el); });
    }
  }

  /* ---------- Visitors outside the US market ----------
     Shopify renders their pages in the backup-region context (Liquid says US) but keeps `Shopify.country` at the
     visitor's real country and marks every variant unavailable. Submit the native localization form once per
     session so they get the US store; if the switch did not stick, reveal the notice with its button. */
  var marketSwitch = document.querySelector('[data-market-switch]');
  var marketForm = marketSwitch && marketSwitch.querySelector('[data-market-switch-form]');
  var visitorCountry = window.Shopify && window.Shopify.country;
  if (marketForm && visitorCountry) {
    var marketCountries = (marketSwitch.getAttribute('data-market-countries') || '').split(',');
    if (marketCountries.indexOf(visitorCountry) === -1) {
      var switched = false;
      try { switched = window.sessionStorage.getItem('goof-market-switch') === '1'; } catch (e) {}
      if (switched) {
        marketSwitch.hidden = false;
      } else {
        try { window.sessionStorage.setItem('goof-market-switch', '1'); } catch (e) {}
        if (marketForm.requestSubmit) marketForm.requestSubmit(); else marketForm.submit();
      }
    }
  }

  /* ---------- Googly eyes ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (goof.googly && !reduceMotion) {
    var pending = false;
    var pointer = { x: 0, y: 0 };
    var look = function () {
      pending = false;
      document.querySelectorAll('[data-googly] .eye').forEach(function (eye) {
        var rect = eye.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var dx = pointer.x - cx;
        var dy = pointer.y - cy;
        var dist = Math.sqrt(dx * dx + dy * dy) || 1;
        var reach = rect.width * 0.2;
        var k = Math.min(1, dist / 160);
        var pupil = eye.firstElementChild;
        pupil.style.setProperty('--px', (dx / dist) * reach * k + 'px');
        pupil.style.setProperty('--py', (dy / dist) * reach * k + 'px');
      });
    };
    var onMove = function (event) {
      pointer.x = event.clientX;
      pointer.y = event.clientY;
      if (!pending) { pending = true; window.requestAnimationFrame(look); }
    };
    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerdown', onMove, { passive: true });
  }
})();
